module.exports = __webpack_public_path__ + "img/backyard-garden-with-flowers.0e5a6d78.webp";